import { FC } from "react";
import { PanelContentContainer } from "~/OnboardingApp/components";
import { Steps } from "./Steps";
import { Title } from "./Title";

export const LeftSection: FC = () => {
  return (
    <PanelContentContainer
      bg="th.yellow1"
      gap={{ base: 6, md: 8 }}
      pb="2rem"
      px="1rem"
    >
      <Title />
      <Steps />
    </PanelContentContainer>
  );
};
